import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchTests } from '../../actions/testActions';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import ExamCards from './ExamCards';


function HomeExamCards() {
    const studentProfileData = useSelector(state => state.dashboard.userData);
    const testsData = useSelector(state => state.tests.tests);
    const loading = useSelector(state => state.tests.loading);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!testsData || testsData.length === 0) {
            dispatch(fetchTests());
        }
    }, []);

    // Sort tests by createdAt (newest first) or updatedAt if createdAt doesn't exist
    const sortedTests = [...testsData].sort((a, b) => {
        const dateA = a.updatedAt || a.createdAt;
        const dateB = b.updatedAt || b.createdAt;
        return new Date(dateB) - new Date(dateA);
    });

    // Take only the first 4 tests after sorting
    const visibleTests = sortedTests.slice(0, 4);

    const handleAttemptTest = async (test) => {
        navigate(`/exam-terms-conditions`, { state: { test, studentProfileData } });
    };

    return (
        <>
            <div className="container mt-4 mb-4 home-card">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center text-primary" style={{ height: '30vh' }}>
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : (<div className="row main-Conatiner">

                    {visibleTests.map((tests, index) => {
                        return (
                            <>
                                <ExamCards key={index} index={index} test={tests} onAttemptTest={handleAttemptTest} />

                            </>
                        )
                    })}
                </div>)}

            </div>
        </>
    )
}

export default HomeExamCards